import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { User } from '../restaurant-manager.models';
import { Injectable } from '@angular/core';
import { Utils } from '../restaurant-manager.utils';

export interface LibConfigurationOptions {
    apiBaseUrl: string;
    imageBaseUrl: string;
    client: string | null;
    platform: string;
}

export class LibConfiguration {

    public static configuration: LibConfigurationOptions = null;
    public static baseUrl = '';
    public static version = '3.30.28';
    public static client: string = null;

    public static conf(configuration: LibConfigurationOptions): void {
        LibConfiguration.configuration = configuration;
        LibConfiguration.configuration.client = configuration.client || LibConfiguration.client;
        LibConfiguration.configuration.platform = configuration.platform ? configuration.platform : 'undefined';
        LibConfiguration.baseUrl = configuration.apiBaseUrl.replace('/api', '');
    }

    static setClient(client: string) {
        LibConfiguration.client = client;
        if (LibConfiguration.configuration) {
            LibConfiguration.configuration.client = client;
        }
    }

    static apiBaseUrl(): string {
        return Utils.combineURLs([LibConfiguration.configuration.apiBaseUrl, LibConfiguration.configuration.client]);
    }

    static imageBaseUrl(): string {
        return LibConfiguration.configuration.imageBaseUrl;
    }

    static imageUrlFromPath(path: string): string {
        if (path) {
            return Utils.combineURLs([LibConfiguration.imageBaseUrl(), path]);
        }
        return null;
    }

    static generatePaymentLink(orderId: string) {
        return Utils.combineURLs([LibConfiguration.apiBaseUrl(), 'orders', orderId, 'pay']);
    }

    static generateOrdersPaymentLink(orderIds: string[], paymentMethod: string) {
        return Utils.combineURLs([LibConfiguration.apiBaseUrl(), 'payments?orderIds=' + orderIds.join('%3B') + '&paymentMethod=' + paymentMethod]);
    }

}

@Injectable({
    providedIn: 'root'
})
export class ApiService {

    static logged = false;
    static user: User = null;
    static token: string = null;

    constructor(private http: HttpClient) {
        const version = localStorage.getItem('rm_version');
        if (LibConfiguration.version !== version) {
            localStorage.setItem('rm_version', LibConfiguration.version);
        }
    }

    public get<T>(url: string, authenticated: boolean = false, client: boolean = true): Observable<T> {
        let headers = new HttpHeaders();
        if (authenticated && ApiService.logged) {
            headers = headers.append('Authorization', 'Bearer ' + ApiService.token);
        }
        headers = headers.append('Client-Platform', LibConfiguration.configuration.platform);
        const baseUrl = client ? LibConfiguration.apiBaseUrl() : LibConfiguration.baseUrl;
        return this.http.get<T>(Utils.combineURLs([baseUrl, url]), { headers });
    }

    public put<T>(url: string, body: any, authenticated: boolean = false, client: boolean = true): Observable<T> {
        let headers = new HttpHeaders();
        if (authenticated && ApiService.logged) {
            headers = headers.append('Authorization', 'Bearer ' + ApiService.token);
        }
        headers = headers.append('Client-Platform', LibConfiguration.configuration.platform);
        const baseUrl = client ? LibConfiguration.apiBaseUrl() : LibConfiguration.baseUrl;
        return this.http.put<T>(Utils.combineURLs([baseUrl, url]), body, { headers });
    }

    public delete<T>(url: string, authenticated: boolean = false, client: boolean = true): Observable<T> {
        let headers = new HttpHeaders();
        if (authenticated && ApiService.logged) {
            headers = headers.append('Authorization', 'Bearer ' + ApiService.token);
        }
        headers = headers.append('Client-Platform', LibConfiguration.configuration.platform);
        const baseUrl = client ? LibConfiguration.apiBaseUrl() : LibConfiguration.baseUrl;
        return this.http.delete<T>(Utils.combineURLs([baseUrl, url]), { headers });
    }

    public post<T>(url: string, body: any, authenticated: boolean = false, client: boolean = true): Observable<T> {
        let headers = new HttpHeaders();
        if (authenticated && ApiService.logged) {
            headers = headers.append('Authorization', 'Bearer ' + ApiService.token);
        }
        headers = headers.append('Client-Platform', LibConfiguration.configuration.platform);
        const baseUrl = client ? LibConfiguration.apiBaseUrl() : LibConfiguration.baseUrl;
        return this.http.post<T>(Utils.combineURLs([baseUrl, url]), body, { headers });
    }

}
